<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#toplist" @click="activeComponent='toplist'" ><i class="fas fa-table-list"></i> Brands</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Toplist from './Tabs/Toplist'

export default {
  data () {
    return {
      activeComponent: 'toplist'
    }
  },
  components: {
    toplist: Toplist
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Toplist/Content.vue